<template>
  <div>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          color="blue-grey"
          v-on="on"
          x-small
          dark
          @click="$refs.inputFile.click()"
        >
          <v-icon small>mdi-arrow-up-circle</v-icon>
        </v-btn>
      </template>
      <span>Cargar documento</span>
    </v-tooltip>

    <input
      type="file"
      ref="inputFile"
      style="display: none"
      @input="subirDocumento"
    />

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="blue-grey" dark>
        <v-card-text>
          Cargando documento - {{ porcentaje }}%
          <v-progress-linear
            color="white"
            class="mb-0"
            :value="porcentaje"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="error" max-width="500">
      <v-card>
        <v-card-title
          ><h5>
            El primer documento debe tener el siguiente nombre:
          </h5></v-card-title
        >
        <v-card-text>
          {{ nombre }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue-grey darken-1" dark small @click="error = false"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  props: ["tipo", "id", "nombre"],
  components: {},
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "userId"]),
  },
  data: () => ({
    loading: false,
    porcentaje: 0,
    error: false,
  }),
  methods: {
    subirDocumento(event) {
      if (event.target.files[0]) {
        let file = event.target.files[0];
        let nombreValido = true;
        // if( this.nombre ){
        //     let name = file.name.split('.');
        //     if( name != this.nombre)
        //         nombreValido = false;
        // }
        // if( !nombreValido){
        //     this.error = true;
        // }
        // if( name[name.length-1] != 'pdf')
        //     this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Debe seleccionar un archivo PDF' });
        // else{
        const formData = new FormData();
        formData.append("archivo", file);
        this.loading = true;
        axios
          .post(
            this.httpURL + "/oficios/documento/" + this.tipo + "/" + this.id,
            formData,
            {
              headers: { token: this.sessionToken },
              onUploadProgress: (e) =>
                (this.porcentaje = Math.round((e.loaded * 100) / e.total)),
            }
          )
          .then((res) => {
            if (res.data.ok) {
              this.$notify({
                group: "gral_notif",
                type: "success",
                duration: 1500,
                speed: 500,
                text: res.data.mensaje,
              });
              this.$emit("documentoCargado", res.data.nuevoDocumento);
              this.$emit("nuevoLog")
            } else {
              this.$notify({
                group: "gral_notif",
                type: "error",
                duration: 1500,
                speed: 500,
                text: res.data.mensaje,
              });
            }
            this.loading = false;
          })
          .catch((error) => {
            this.$notify({
              group: "gral_notif",
              type: "error",
              duration: 1500,
              speed: 500,
              text: "No se pudo realizar la operación.",
            });
            this.loading = false;
          });
        // }
      }
    },
  },
};
</script>